export function receiptLabel(status, language = 'zh') {
  const labels = language === 'ja' ? ['入金済み', '未入金', '未登録'] : language === 'en' ? ['Received', 'Not received', 'Not recorded'] : ['已收款', '未收款', '未登记'];
  return labels[status === 'paid' ? 0 : status === 'unpaid' ? 1 : 2];
}

export default function ExtraScheduleReceipt({ schedule, language = 'zh' }) {
  if (schedule.creation_origin !== 'internal') return null;
  return <span className="text-sm break-words" data-testid="extra-receipt">
    {receiptLabel(schedule.receipt_status, language)} · {schedule.price_currency === 'CNY' ? 'CNY' : 'JPY'}
  </span>;
}
